var MapShopsComponent;
var magicMap;

(function($, dom, utils) {

	var MapDetailComponent = Vue.component('map-detail-vue', {
		template: '#map-detail-vue',
		props: ['action', 'closeDetail']
	});

	MapShopsComponent = Vue.component('map-shops', {
		template: '#map-shops',
		data: function() {
			return {
				id: '',
				storeFloor: '',
				list: [],
				action: []
			}
		},

		components: {
			MapDetailComponent: MapDetailComponent
		},

		mounted: function() {
			// Переход к карте в тултипе
			var $box =  $('.shops'),
				$gotoMap = $box.find('.js-gotoMap');

			$gotoMap.on('click', function() {
				$('.map').addClass('disable');

				$box.fadeOut(100, function(){
					$('.map').fadeIn(0, function(){
						var arr = vueApp.$refs.mapShops.gotoMap();
						CommonHelpers.searchMap(null, arr);
					});
					$('.js-map-switch').find('.switch__item').removeClass('active');
					$('.js-map-switch').find('.switch__item[data-view="map"]').addClass('active');
				});
			});

			this.mobile();
		},

		methods: {

			mobile: function() {
				if (app.sizes.width < app.mobileTo) $('.content').append($('.blockMapDetail'));
			},

			gotoMap: function() {
				var arr = {
					id: '',
					floor: ''
				};
				arr.id = this.id;
				arr.floor = this.storeFloor;
				return arr;
			},

			getDataArr: function(storeId, floor) {
				this.id   = storeId;
				this.storeFloor  = floor;
			},

			showTooltip: function(catIndex, storeId, floor) {
				vueApp.$refs.mapShops.getDataArr(storeId, floor);
				this.action = this.list[catIndex].stores.filter(function(el) {
					return storeId === el.id;
				})[0];
			},

			changeView: function() {
				var $mapSwitch     = $('.js-map-switch'),
						$blockMapLeft  = $('.blockMap__left'),
						$blockMap      = $blockMapLeft.find('.map'),
						$blockMapShops = $blockMapLeft.find('.shops');

				$mapSwitch.find('.switch__item').removeClass('active');
				$mapSwitch.find('.switch__item[data-view="map"]').addClass('active');

				$blockMap.fadeIn('fast');
				$blockMapShops.fadeOut('fast');
			},

			getData: function(idShop, catId) {
				var url = '/static/components-assets/blockMapList/dataContacts.json';

				if(CommonHelpers.isDev('gold-babylon-static.denode.ru'))
					url = 'static/components-assets/blockMap/dataContacts.json';

				// todo сделать localstorage
				if(!this.list.length) {
					this.$http
						.get(url, {
							params: {
								action: 'getShops'
							}
						})
						.then(function(response) {
							var data    = response.body.data;

							var list    = [],
									catType = [];

							// имя категории
							$(data).each(function(i, el) {
								// подкатегория
								$(el.types).each(function(i, type) {
									var stores = [];

									catType = type.typeName;

									// магазины
									$(type.stores).each(function(i, store) {
										stores.push(store);
									});

									list.push({
										catId: el.catId,
										catName: el.catName,
										typeName: catType,
										stores: stores
									});
								});
							});

							this.list = list;

							this.$nextTick(function() {
								this.scriptsInit();
								this.showDetail(idShop, catId);
							});
						},
						function(response) { // Error.
							console.log('An error occurred.');
						}
					);
				} else {
					this.$nextTick(function() {
						this.showDetail(idShop, catId);
					});
				}
			},

			scriptsInit: function() {
				var $box            = $('.shops'),
						$tooltip        = $box.find('.tooltip_fixed'),
						$scroller       = $box.find('.js-custom-scroll'),
						$prev           = $box.find('.js-prev-scroll'),
						$next           = $box.find('.js-next-scroll');

				app.utils.scroller($scroller, $prev, $next);
				app.utils.tooltip($tooltip, '.shops');
			},

			showDetail: function(idShop, catId) {

				if (app.sizes.width < app.mobileTo) { // for mobile
					if (idShop && catId) {
						var action = this.action;

						$.each(this.list, function(i, category){
							if (category.catId == catId) {

								$.each(category.stores, function(i, el){
									if (idShop === el.id) action = el;
								});
							}
						});


						if (action) {
							this.action = action;

							$('.blockMapDetail').addClass('open');

							setTimeout(function(){
								$('html, body').addClass('overflow--detail');
							}, 500);

						} else console.log('shop is not found');

					} else console.log('catId indefined');
				}
			},

			closeDetail: function() {
				$('.blockMapDetail').removeClass('open');
				$('html, body').removeClass('overflow--detail');
				$('.mapPopup').removeClass('open--detail');
				$(window).scrollTop($('.box_blockMap').offset().top - $('.header__left').outerHeight());
			}
		}
	});

	$(function() {
		var $mapSwitch = $('.js-map-switch'),
				$box = $('.box_blockMap'),
				$blockMapLeft = $box.find('.blockMap__left'),
				$blockMap = $blockMapLeft.find('.map'),
				$blockMapShops = $blockMapLeft.find('.shops'),
				$navItems = $box.find('.blockMapNav__item');

		// Переключение Карта/Магазины
		$mapSwitch.on('click', '.switch__item', function(e) {
			var dataView = $(this).data('view');

			$mapSwitch.find('.switch__item').removeClass('active');
			$(this).addClass('active');

			if(dataView === 'map') {
				$blockMap.fadeIn(450);
				$blockMapShops.fadeOut(450);
			}

			if(dataView === 'shops') {
				$blockMap.fadeOut(450);
				$blockMapShops.fadeIn(450);

				vueApp.$refs.mapShops.getData();
			}
		});

		if (app.sizes.width < app.mobileTo) {
			var $sliderMap = $box.find('.sliderMap'),
				$slides = $sliderMap.find('.sliderMap__item'),
				$mapPopup = $('.mapPopup'),
				$closeMapPopup = $mapPopup.find('.mapPopup__close');

			var swiper = new Swiper('.sliderMap .swiper-container', {
				pagination: '.sliderMap .swiper-pagination',
				paginationClickable: true,
				paginationBulletRender: function (swiper, index, className) {
					return '<span class="swiper-pagination-bullet">'+ index +' этаж</span>';
				},
				loop: true,
				initialSlide: 1,
				nextButton: '.sliderMap .swiper-button-next',
				prevButton: '.sliderMap .swiper-button-prev'
			});

			$slides.on('click', function(){
				$mapPopup.addClass('open');

				setTimeout(function(){
					$('html, body').addClass('overflow--map');
				}, 500);

				var index = $(this).data('floor'),
					$map = $mapPopup.find('.map');

				$map.remove();
				$mapPopup.append('<div class="map"></div>');
				CommonHelpers.getDataMap(index);

				setTimeout(function(){ //- демонстрация скролла карты внутри попапа
					var $mapCurr = $mapPopup.find('.map');

					$mapCurr.addClass('show').animate({
						scrollLeft: $mapCurr.find('svg').width()
					}, 2000);
				}, 1000);

				$closeMapPopup.on('click', function(){
					$mapPopup.removeClass('open');
					$('html, body').removeClass('overflow--map');
					$(window).scrollTop($('.box_blockMap').offset().top - $('.header__left').outerHeight());
					$mapPopup.find('.map').remove();
				});
			});
		}

		/**
		 * Инит карты
		 * @param map {object}
		 */
		magicMap = function(map, surrEl) {
			$('.map').each(function() {
				var $wrapper = $(this),
					$box       = $('.box_blockMap'),
					$focus     = $box.find('.focus'),
					$close     = $box.find('.close'),
					$navItems  = $box.find('.blockMapNav__item'),
					$button    = $box.find('.blockMapIcons__item'),
					mainPaper  = Raphael($wrapper.get(0), map.viewBox[0], map.viewBox[1]);

				// - проверка на существование элементов
				if (map.wc == 'no') $button.filter('[data-item="wc"]').addClass('disabled');
				else $button.filter('[data-item="wc"]').removeClass('disabled');

				if (map.cafe == 'no') $button.filter('[data-item="cafe"]').addClass('disabled');
				else $button.filter('[data-item="cafe"]').removeClass('disabled');

				if (map.elevator == 'no') $button.filter('[data-item="elevator"]').addClass('disabled');
				else $button.filter('[data-item="elevator"]').removeClass('disabled');


				if (app.dom.$content.find('.mapTooltip').length) {
					var $tooltip = app.dom.$content.find('.mapTooltip'),
						$tooltipName = $tooltip.find('.mapTooltip__name'),
						$tooltipInfo = $tooltip.find('.mapTooltip__info');
				} else {
					var $tooltip = app.dom.$content.append('<div class="mapTooltip" />').find('.mapTooltip'),
						$tooltipName = $tooltip.append('<div class="mapTooltip__name" />').find('.mapTooltip__name'),
						$tooltipInfo = $tooltip.append('<div class="mapTooltip__info" />').find('.mapTooltip__info');
				};

				if (app.dom.$content.find('.surrTooltip').length) {
					var $surrTooltip = app.dom.$content.find('.surrTooltip'),
						$surrTooltipName = $surrTooltip.find('.surrTooltip__name'),
						$surrTooltipInfo = $surrTooltip.find('.surrTooltip__info');
				} else {
					var $surrTooltip = app.dom.$content.append('<div class="surrTooltip" />').find('.surrTooltip'),
						$surrTooltipName = $surrTooltip.append('<div class="surrTooltip__name" />').find('.surrTooltip__name'),
						$surrTooltipInfo = $surrTooltip.append('<div class="surrTooltip__info" />').find('.surrTooltip__info');
				};

				mainPaper.setViewBox(0, 0, map.viewBox[0], map.viewBox[1], true);

				$.each(map.buildings, function(index, build) {
					// - path start
					var buildPath = mainPaper.path(build.path),
						id = build.id || '';

					buildPath.attr({
						opacity: 0,
						'stroke-width': 0,
						fill: build.fill
					});

					if (build.class != 'empty') {
						// - text start
						if (build.text) {
							var buildText = mainPaper.text(build.text.x, build.text.y, build.name);

							if (build.text.vertical) {
								buildText.node.setAttribute('style', 'text-transform:uppercase; font-family:"GothamProBold"; will-change: transform; transform:rotate(-90deg) translateZ(0);');
							} else {
								buildText.node.setAttribute('style', 'text-transform:uppercase; font-family:"GothamProBold";');
							}
							if (build.text.class) {
								buildText.node.setAttribute('class', build.text.class);
							}
							buildText.attr({
								opacity: 0,
								'font-size': build.text.size
							}).toFront();

							if (build.id) {
								buildText.node.setAttribute('id', id);
							};
							setTimeout(function(){
								buildText.animate({opacity: 1}, 250);
							}, 450);
						};
					}


					if (build.id) {
						buildPath.node.setAttribute('id', id);
					};

					// - focus element
					if ((typeof surrEl != 'undefined') && (id == surrEl)) {
						buildPath.node.setAttribute('class', 'active');

						$surrTooltipName.html(build.name);
						$surrTooltipInfo.html(build.info);
						$surrTooltip.addClass('show');
						$wrapper.addClass('disable');

						var height = $surrTooltip.outerHeight(),
							width = $surrTooltip.outerWidth(),
							$surrText = $wrapper.find('text#'+id),
							x = $surrText.attr('x'),
							y = $surrText.attr('y');

						if (x < 0) {
							$surrTooltip.css({
								left: $surrText.offset().left - 15,
								top: $surrText.offset().top - height + 15
							});
						} else {
							$surrTooltip.css({
								left: $surrText.offset().left,
								top: $surrText.offset().top - height - 15
							});
						}


						$box.on('click', function(){
							app.dom.$page.removeClass('focus');
							$wrapper.removeClass('disable');
							$surrTooltip.removeClass('show');
							buildPath.node.setAttribute('class', build.class);
						});
						app.dom.$page.on('mousewheel', function(){
							app.dom.$page.removeClass('focus');
							$wrapper.removeClass('disable');
							$surrTooltip.removeClass('show');
							buildPath.node.setAttribute('class', build.class);
						});
					} else {
						buildPath.node.setAttribute('class', build.class);
					};

					if (build.class == 'decor') buildPath.toBack();

					// - circle start
					if (build.circle) {
						var buildCircle = mainPaper.circle(build.circle.x, build.circle.y, build.circle.radius);

						buildCircle.attr({
							opacity: 0,
							'stroke-width': 0,
							fill: build.circle.fill
						});
						buildCircle.toBack();
						setTimeout(function(){
							buildCircle.animate({opacity: 1}, 250);
						}, 450);
					};

					// - animation fadeIn
					buildPath.animate({opacity: 1}, 250);

					// buildPath.click(function(){
					// 	var url = build.link;
					// 	$(location).attr('href', url);
					// });

					// - tooltip start
					if (build.info) {

						var isMobile = function() {
							if (app.sizes.width < app.mobileTo) {
								buildPath.click(function(){
									var idShop = build.id,
										catId = build.catId;

									$('.mapPopup').addClass('open--detail');
									// $('.mapPopup').removeClass('open');
									// $('html, body').removeClass('overflow--map');
									vueApp.$refs.mapShops.getData(idShop, catId);
								});
							} else {
								buildPath.hover(function(event) {
									var height = $tooltip.outerHeight();

									setTooltip(build.name, build.info);

									$tooltip.css({
										left: event.pageX - app.dom.$content.offset().left - 20,
										top: event.pageY - app.dom.$content.offset().top - height - 15
									});

									$tooltip.addClass('show');
								}, function() {
									$tooltip.removeClass('show');
								});
							}
						};
						isMobile();
					};

					// - animation start
					$button.on('click', function(){
						var $activeButton = $(this),
							data = $(this).data('item'),
							typeClass = build.class || '';

						$('.shops').fadeOut(450, function(){
							$wrapper.fadeIn(450, function(){

								$activeButton.addClass('disabled');

								if (typeClass.indexOf('el-border') > -1) {
									if (data == 'elevator') {
										buildPath.stop().animate({
											transform: 's1.5,1.5'
										}, 1000, function(){
											this.animate({
												transform: 's1,1'
											}, 700, function(){
												this.animate({
												transform: 's1.5,1.5'
												}, 450, function(){
													this.animate({
														transform: 's1,1'
													}, 700, function(){
														$activeButton.removeClass('disabled');
													});
												});
											});
										});
									}
								}
								if (typeClass.indexOf(data) > -1) {
									if (data == 'elevator') {
										buildPath.stop().animate({
											transform: 's1.5,1.5'
										}, 500, function(){
											this.animate({
												transform: 's1,1'
											}, 500, function(){
												$activeButton.removeClass('disabled');
											});
										});
									} else if (data == 'wc') {
										buildPath.stop().animate({
											fill: '#909090'
										}, 500, function(){
											this.animate({
												fill: build.fill
											}, 500, function(){
												$activeButton.removeClass('disabled');
											});
										});
									} else if (data == 'cafe') {
										buildPath.stop().animate({
											fill: '#3f3c04'
										}, 500, function(){
											this.animate({
												fill: build.fill
											}, 500, function(){
												$activeButton.removeClass('disabled');
											});
										});
									}
								}
							});
							$('.js-map-switch').find('.switch__item').removeClass('active');
							$('.js-map-switch').find('.switch__item[data-view="map"]').addClass('active');
						});
					});
				});

				$wrapper.mousemove(function(event) {
					var height = $tooltip.outerHeight();

					$tooltip.css({
						left: event.pageX - app.dom.$content.offset().left - 20,
						top: event.pageY - app.dom.$content.offset().top - height - 15
					});
				});

				function setTooltip (name, info) {
					$tooltipName.html(name);
					$tooltipInfo.html(info);
				};
			});
		};

		/**
		 * Изменить этаж
		 */
		changeFloor = function(id) {
			$('.map').each(function() {
				var $wrapper = $(this),
					$box = $('.box_blockMap'),
					$navItems = $box.find('.blockMapNav__item');

				if (typeof id == 'undefined') {
					$navItems.filter('[data-floor="1"]').addClass('active');
				} else {
						var $navItem = $navItems.filter('[data-floor="'+id+'"]');
						if (!$navItem.hasClass('active')) {
							$navItems.removeClass('active');
							$navItem.addClass('active');

							$wrapper.find('svg').animate({opacity: 0}, 450, function() {
								this.remove();
							});
							CommonHelpers.getDataMap(id);
						};
				};

				$navItems.on('click', function(){
					var $navItem = $(this),
						floorId = $navItem.data('floor') || 0;

					$('.shops').fadeOut(450, function(){
						$wrapper.fadeIn(450);
						$('.js-map-switch').find('.switch__item').removeClass('active');
						$('.js-map-switch').find('.switch__item[data-view="map"]').addClass('active');
					});

					if (!$navItem.hasClass('active')) {
						$navItems.removeClass('active');
						$navItem.addClass('active');

						$wrapper.find('svg').animate({opacity: 0}, 450, function() {
							this.remove();
						});
						CommonHelpers.getDataMap(floorId);
					};
				});
			});
		};

		changeFloor();
	});
})(jQuery, app.dom, app.utils);
